/* eslint-disable no-unused-vars */
// eslint-disable-next-line max-len
import cashIcon from "../assests/images/cashIcon.svg";
import accountBookingIcon from "../assests/images/AccountBookingsvg.svg";
import viewBookingIcon from "../assests/images/viewBookingIcon.svg";
import master_setting from "../assests/images/master-setting.svg";
import message_alerts from "../assests/images/message-alerts.svg";
import onboarding_setting from "../assests/images/onboarding-setting.svg";
import configurationIcon from "../assests/images/SVG/configure-setting.svg";
import hub_in_scan from "../assests/images/SVG/hub-in-scan.svg";
import hub_inbound from "../assests/images/SVG/hub-inbound.svg";
import hub_outbound from "../assests/images/hub-outbound.svg";
import hub_inbound_new from "../assests/images/hub-inbound.svg";
import create_print_lcr from "../assests/images/create-printlcr.svg";
import extend_way from "../assests/images/extend-way.svg";
import reports_new from "../assests/images/repots-new.svg";
import audit_new from "../assests/images/audit-new.svg";
import config_guide_new from "../assests/images/config-guide.svg";
import master_setting_new from "../assests/images/master-setting-new.svg";
import mcn_new from "../assests/images/mcn-new.svg";
import training_video_new from "../assests/images/training-video.svg";
import onboarding_setting_new from "../assests/images/onboard-setting-new.svg";
import approvals_new from "../assests/images/approvals-new.svg";
import escalation_matrix_new from "../assests/images/exclation-matrix.svg";
import lost_damage_new from "../assests/images/lost-damage.svg";
import message_alert_new from "../assests/images/message-alert.svg";
import shipment_status_new from "../assests/images/shipment-status.svg";
import last_mile_icon from "../assests/images/lastMileLogo.svg";
import QRScanner from "../assests/images/QRScanner.svg";
import audit from "../assests/images/SVG/audit-dash.svg";
import report from "../assests/images/SVG/report-img.svg";
import support_contact from "../assests/images/SVG/contact-support.svg";
import constants from "../constants/constants";
import extend from "../assests/images/extentEway.svg";
import product from "../assests/images/stationaryProduct.svg";
import product_request from "../assests/images/product-request.svg";
import my_order from "../assests/images/my-order.svg";
import create_trip from "../assests/images/middleMile/create-trip.svg";
//import create_trip from "../../../assests/images/middleMile/create-trip.svg";
import client_approval from "../assests/images/SVG/client_approval.svg";
import middle_mile_tat from "../assests/images/master/middle-mile-tat.svg";
import route from "../assests/images/master/route.svg";
import lockIcon from "../assests/images/locking.svg";
const { ROLES } = constants;
const {
  CP_ADMIN,
  HO_ADMIN,
  HUB_ADMIN,
  ROLE_HOMARKETING,
  ROLE_ZONALHEAD,
  ROLE_ZONALOPERATOR,
  ROLE_RM,
  ROLE_FUNCTIONALHEAD,
  ROLE_MD,
  ROLE_CENTRALOPERATOR,
  ROLE_HOOPERATOR,
  ROLE_BOOKINGAUDITONLY,
  ROLE_HUBOPERATOR,
  DEVELOPER,
  CUSTOMER_DELIGHT_EXECUTIVE,
  ROLE_CSO,
  ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM
} = ROLES;

export const dashboardMenuList = [
  {
    icon: hub_outbound,
    title: "Hub Outbound",
    id: "middle-mile",
    additionalClass: "",
    route: "/middle-mile",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },
  {
    icon: hub_inbound_new,
    title: "Hub Inbound",
    id: "hub-in-scan",
    additionalClass: "",
    route: "/hub-in-scan",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },
  {
    icon: create_print_lcr,
    title: "Create & Print LCR",
    id: "create-view-trip",
    additionalClass: "",
    route: "/lcr-generation",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },
  {
    icon: extend_way,
    title: "Extend E-way",
    id: "e-way",
    additionalClass: "",
    route: "/extend-eway",
    role: [HUB_ADMIN, DEVELOPER],
  },
  {
    icon: reports_new,
    title: "Reports",
    id: "report",
    additionalClass: "",
    route: "/reports",
    newReportUrl: "/",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_CENTRALOPERATOR, ROLE_BOOKINGAUDITONLY, ROLE_HUBOPERATOR, DEVELOPER, CUSTOMER_DELIGHT_EXECUTIVE, ROLE_HOCRM, ROLE_HO_CRM_CP],
  },
  {
    icon: audit_new,
    title: "Audit",
    id: "view-audit",
    additionalClass: "",
    route: "/manifest-audit",
    role: [HO_ADMIN, HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },
  {
    icon: config_guide_new,
    title: "Config Guide",
    id: "configuration-guide",
    additionalClass: "",
    route: "/configuration-guide",
    role: [HUB_ADMIN, DEVELOPER],
  },
  {
    icon: master_setting_new,
    title: "Master Setting",
    id: "master-setting",
    additionalClass: "",
    route: "/masters",
    role: [HO_ADMIN, HUB_ADMIN, DEVELOPER, ROLE_CENTRALOPERATOR, ROLE_HOOPERATOR, ROLE_FUNCTIONALHEAD,
      ROLE_ZONALHEAD,
      ROLE_ZONALOPERATOR,
      ROLE_RM,
      ROLE_MD,
      ROLE_CENTRALOPERATOR,
      ROLE_BOOKINGAUDITONLY,
      ROLE_HUBOPERATOR,
      CP_ADMIN,
      ROLE_HOMARKETING,
      ROLE_CSO,
      ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM,
    ],
  },
  {
    icon: onboarding_setting_new,
    title: "Onboard Setting",
    id: "onboarding-settings",
    additionalClass: "",
    route: "/onboarding-settings",
    role: [CP_ADMIN, HO_ADMIN, HUB_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },
  {
    icon: training_video_new,
    title: "Training Videos",
    id: "training-videos",
    additionalClass: "",
    route: "/training-videos",
    //all roles
    role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    icon: approvals_new,
    title: "Approvals",
    id: "approvals",
    additionalClass: "",
    route: "/approvals-settings",
    //all roles
    role: [CP_ADMIN, HO_ADMIN, HUB_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },
  {
    icon: report,
    id: "director-dashboard",
    title: "Director Dashboard",
    additionalClass: "",
    route: "/director-dashboard",
    role: [ROLE_MD],
  },
  {
    icon: message_alert_new,
    title: "Message & Alert",
    id: "messageAlert",
    additionalClass: "",
    route: "/message-and-alerts",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    icon: report,
    id: "director-dashboard",
    title: "Director Dashboard new",
    additionalClass: "",
    route: "/director-dashboardNew",
    role: [ROLE_MD],
  },
  {
    icon: mcn_new,
    id: "MCN",
    title: "MCN",
    additionalClass: "",
    route: "/mcn",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER, HO_ADMIN, ROLE_CENTRALOPERATOR,],
  },
  {
    icon: lockIcon,
    id: "lock-management",
    title: "Lock Management",
    additionalClass: "",
    route: "/locking-management-dashboard",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    icon: shipment_status_new,
    id: "shipment-status",
    title: "Shipment Status",
    additionalClass: "",
    route: "/shipment-status",
    role: [HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    icon: lost_damage_new,
    id: "mark-lost-damage",
    title: "Mark Lost / Damage/ On Hold",
    additionalClass: "",
    route: "/mark-lost-damage",
    role: [HUB_ADMIN, HO_ADMIN, DEVELOPER],
    hideOnDashboard: true,
  },

  // {
  //   icon: route,
  //   title: "Vehicle route master",
  //   additionalClass: "",
  //   route: "/hub-route-configuration",
  //   role: [ROLE_MD, ROLE_RM, ROLE_ZONALOPERATOR, ROLE_ZONALHEAD, ROLE_FUNCTIONALHEAD],
  // },
  // {
  //   icon: middle_mile_tat,
  //   title: "Shipment Routes",
  //   additionalClass: "",
  //   route: "/route-configuration?type=SURFACE",
  //   role: [ROLE_MD, ROLE_RM, ROLE_ZONALOPERATOR, ROLE_ZONALHEAD, ROLE_FUNCTIONALHEAD,],
  // },
  {
    icon: report,
    title: "Control Tower Reports",
    id: "control-tower-reports",
    additionalClass: "",
    route: "/control-tower-reports",
    role: [ROLE_CSO,],
  },
  {
    icon: report,
    title: "Non-FT Premium Bookings Report",
    id: "non-ft-premium-bookings-report",
    additionalClass: "",
    route: "/non-ft-premium-bookings-report",
    role: [ROLE_CSO,],
  },
  {
    icon: report,
    title: "Central Ops Dashboard",
    id: "central-ops-dashboard",
    additionalClass: "",
    route: "/central-ops-dashboard",
    role: [ROLE_FUNCTIONALHEAD],
  },
  {
    icon: escalation_matrix_new,
    id: "support-and-contact",
    title: "Escalation Matrix",
    additionalClass: "",
    route: "/support-and-contact",
    role: [HO_ADMIN, ROLE_CENTRALOPERATOR, DEVELOPER],
  },

  // {
  //   icon: cashIcon,
  //   title: "Retail Booking",
  //   id: "cash-booking",
  //   additionalClass: "",
  //   route: "/retail-booking",
  //   role: [CP_ADMIN],
  // },
  // {
  //   icon: accountBookingIcon,
  //   title: "Credit Booking",
  //   id: "account-booking",
  //   additionalClass: "",
  //   route: "/credit-booking",
  //   role: [CP_ADMIN],
  // },
  // {
  //   icon: viewBookingIcon,
  //   title: "View Booking",
  //   id: "view-booking",
  //   additionalClass: "",
  //   route: "/viewBooking",
  //   role: [CP_ADMIN],
  // },
  // {
  //   icon: last_mile_icon,
  //   title: "Last Mile Ops",
  //   id: "last-mile-operations",
  //   additionalClass: "",
  //   route: "/last-mile-operations",
  //   role: [CP_ADMIN],
  // },
  // {
  //   icon: QRScanner,
  //   title: "Vehicle Check-In",
  //   id: "view-audit",
  //   additionalClass: "",
  //   route: null,
  //   role: [HUB_ADMIN],
  // },


  // {
  //   icon: trip_scheduler,
  //   title: "Trip Scheduler",
  //   id: "trip-scheduler",
  //   additionalClass: "",
  //   route: "/trip-scheduler",
  //   role: [HUB_ADMIN],
  // },
  // {
  //   icon: product,
  //   title: "Products",
  //   id: "stationary-product",
  //   additionalClass: "",
  //   route: "/stationery",
  //   role: [HO_ADMIN,DEVELOPER],
  // },

  // {
  //   icon: product,
  //   title: "Request Products",
  //   id: "stationery",
  //   additionalClass: "",
  //   route: "/product-list",
  //   role: [CP_ADMIN, HUB_ADMIN,DEVELOPER],
  // },
  // {
  //   icon: my_order,
  //   title: "My Orders",
  //   id: "my-order",
  //   additionalClass: "",
  //   route: "/order-history",
  //   role: [CP_ADMIN, HUB_ADMIN,DEVELOPER],
  // },
  //log
  // {
  //   icon: product,
  //   title: "API Log",
  //   id: "api-log",
  //   additionalClass: "",
  //   route: "/api-log",
  //   role: [HO_ADMIN,DEVELOPER],
  // },

];
